/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-02 23:53:12
 **/

import { useAtom, useAtomValue } from "jotai";
import { useProperties } from "@/frameworks/libraries/properties";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#useWidget#";

export default function useWidget() {
	const properties = useProperties();
	const mydeskWallpaper = useAtomValue<string>(properties.propertyAtom("mydeskWallpaper"));
	const [widgets, setWidgets] = useAtom<AllProperties["widgets"]>(properties.propertyAtom("widgets"));

	return {
		wallpaper: mydeskWallpaper,
		widgets,
		add: setWidgets
	};
}
